import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'eze-registration-error',
	templateUrl: './registration-error.component.html',
	styleUrls: ['./registration-error.component.css']
})
export class RegistrationErrorComponent implements OnInit {
	@Input() eventName = '';
	@Input() formName = '';
	@Input() url = '';
	email = 'info@ez-events.com';

	get mailToLink(): string {
		const subject = encodeURI(`[Help] ${this.eventName} - ${this.capitalize(this.formName)} Registration`);
		return `mailto:${this.email}?Subject=${subject}`;
	}

	constructor() { }

	ngOnInit() {

	}

	capitalize(value: string) {
		if (!value) {
			return '';
		}
		return value[0].toUpperCase() + value.slice(1);
	}

}
